import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { filter } from 'rxjs';
import { CleanDatePipe } from 'src/app/pipes/clean-date.pipe';
import { AccessService } from '../../navigation/service/access.service';
import { ContactMechanismPurposeTypes } from '../../party/model/contact-mechanism-purpose-types.model';
import { ContactMechanismTypes } from '../../party/model/contact-mechanism-types.model';
import { PartyContactMechanisms } from '../../party/model/party-contact-mechanisms.model';
import { PartyRoleTypes } from '../../party/model/party-role-types.model';

import { PCMEditInterface } from '../model/pcm-edit-interfacte';
import { Phone } from './phone';
import { CoeRelatedStudent, STUDENT } from '../multi-select-coe-student/coe-related-student';
import { StudentService } from '../../children/service/student.service';

@Component({
    selector: 'app-phone',
    templateUrl: './phone.component.html',
    styleUrls: ['./phone.component.scss']
})
export class PhoneComponent implements OnInit, AfterViewInit, OnChanges {
    @ViewChild(MatPaginator) paginator: MatPaginator;
    displayedColumns: string[] = PhoneColumns.map((col) => col.key);
    columnsSchema: any = PhoneColumns;
    dataSource = new MatTableDataSource<Phone>();
    contactMechanismTypes: ContactMechanismTypes[] = [];
    contactMechanismPurposeTypes: ContactMechanismPurposeTypes[] = [];
    relatedPartyContactMechStudents: STUDENT[] = [];
    initialPartyContactMech: PartyContactMechanisms;

    partyRoleType!: PartyRoleTypes;
    lstTelePhonedata: Phone[] = [];

    kidsInfoByCoe: boolean = false;
    CoeRelatedStudents: CoeRelatedStudent[] = [];

    coeChildSpinner: boolean = false;

    @Input() type!: 'People' | 'Organization' | 'Student';
    @Input() filterTypes: string[] = [];
    @Input() refresh: boolean = false;
    @Input() readOnly: boolean = false;
    @Input() editing: boolean;
    @Input() initialCoeRelatedStudents: CoeRelatedStudent[] = [];
    @Input() data: PartyContactMechanisms[] = [];
    @Input() partyId: number;

    @Output() partyContactMechanismsChange: EventEmitter<PCMEditInterface> = new EventEmitter<PCMEditInterface>();

    constructor(
        public dialog: MatDialog,
        //private contactMechanismsService: ContactMechanismsService,
        //private partyRolesService: PartyRolesService,
        private accessService: AccessService,
        private studentService: StudentService,
        private cleanDatePipe: CleanDatePipe
    ) {}

    ngOnInit(): void {
        this.getContactMechanismTypes();
        this.getContactMechanismPurposeTypes();
        this.getPartyRoleType();
        //this.getCoeRelatedStudents();
    }

    populateTelePhoneData() {
        this.lstTelePhonedata = [];

        if (this.data) {
            const now = new Date().getTime();
            const type = this.type === 'People' || '' ? 'Person' : this.type;
            let filterParyContanctMechanisms: PartyContactMechanisms[] = this.data.filter(
                (x) => (x.CONTACT_MECHANISMS?.CONTACT_MECHANISM_TYPES?.TYPE === 'Phone' && 
                (x.PARTY_ROLE_TYPES?.TYPE == type || x.PARTY_ROLE_TYPES?.TYPE == 'Employee'))
            );

            filterParyContanctMechanisms.forEach((p) => {
                p.CREATED_DATE = new CleanDatePipe().transform(p.CREATED_DATE!);
            });

            filterParyContanctMechanisms.sort((a, b) => {
                return (b.CREATED_DATE ? b.CREATED_DATE!.getTime() : now) - (a.CREATED_DATE ? a.CREATED_DATE!.getTime() : now);
            });

            let currentPCM: PartyContactMechanisms[] = [];
            let pastPCM: PartyContactMechanisms[] = [];

            this.filterTypes.forEach((type) => {
                let filterPCMbyTypes = filterParyContanctMechanisms.filter(
                    (x) => x.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE === type
                );
                if (filterPCMbyTypes.length == 1) {
                    currentPCM.push(filterPCMbyTypes[0]);
                } else {
                    filterPCMbyTypes.sort((a, b) => {
                        return (b.CREATED_DATE ? b.CREATED_DATE!.getTime() : now) - (a.CREATED_DATE ? a.CREATED_DATE!.getTime() : now);
                    });

                    filterPCMbyTypes.forEach((pcmtype, index) => {
                        if (index == 0) currentPCM.push(pcmtype);
                        else pastPCM.push(pcmtype);
                    });
                }
            });

            currentPCM.forEach((element) => {
                this.lstTelePhonedata.push({ isEdit: false, partyContactMechanisms: element });
            });
            pastPCM.forEach((element) => {
                this.lstTelePhonedata.push({ isEdit: false, partyContactMechanisms: element });
            });
        }

        this.dataSource.data = this.lstTelePhonedata;
    }

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
    }
    ngOnChanges(changes: SimpleChanges): void {
        this.populateTelePhoneData();
        this.kidsInfoByCoe = false;
    }

    addRow() {
        this.kidsInfoByCoe = true;
        this.relatedPartyContactMechStudents = [];
        this.CoeRelatedStudents = JSON.parse(JSON.stringify(this.initialCoeRelatedStudents));
        this.dataSource.data.findIndex((x) => x.isEdit == true) == -1
            ? (this.dataSource.data = [{ isEdit: true, partyContactMechanisms: this.buildContactMechanisms() }, ...this.dataSource.data])
            : null;

        this.ngAfterViewInit();
    }

    editRow(row: Phone) {
        if (this.dataSource.data.findIndex((x) => x.isEdit == true) === -1) {
            this.CoeRelatedStudents = JSON.parse(JSON.stringify(this.initialCoeRelatedStudents));
            if (!this.kidsInfoByCoe) this.kidsInfoByCoe = true;
            if (this.dataSource.data.findIndex((x) => x.isEdit == true) === -1) {
                this.initialPartyContactMech = new PartyContactMechanisms();
                this.initialPartyContactMech = JSON.parse(JSON.stringify(row.partyContactMechanisms));
                row.isEdit = true;
            }
        }
    }

    updateRow(row: Phone) {
        this.kidsInfoByCoe = false;
        row.isEdit = false;
        if (this.relatedPartyContactMechStudents.length > 0)
            row.partyContactMechanisms.RELATED_PARTY_CONTACT_MECHANISM_STUDENTS = this.relatedPartyContactMechStudents;
        this.emitdataSource(undefined, row.partyContactMechanisms.ID);
    }

    RemoveCallCoeRelatedStudents(row: Phone) {
        if (this.dataSource.data.findIndex((x) => x.isEdit == true) === -1) {
            if (row.partyContactMechanisms.ID! < 0) {
                this.deleteRow(row);
            } else {
                this.CoeRelatedStudents = [];
                this.coeChildSpinner = true;
                this.kidsInfoByCoe = true;
                this.initialPartyContactMech = new PartyContactMechanisms();
                this.initialPartyContactMech = JSON.parse(JSON.stringify(row.partyContactMechanisms));

                row.isEdit = true;
                row.isDelete = true;

                let requestPayload = { party: { ID: this.partyId }, partyContactMechanism: row.partyContactMechanisms };

                this.studentService.getCoeRelatedStudentsByContactMechanism(requestPayload).subscribe((x) => {
                    if (x['coes'] === undefined) {
                        if (x['msg'] !== undefined) {
                            //this.msg = x['msg'];
                            this.CoeRelatedStudents = [];
                            this.coeChildSpinner = false;
                        }
                    } else {
                        //if (!this.kidsInfoByCoe) this.kidsInfoByCoe = true;
                        this.CoeRelatedStudents = JSON.parse(x['coes']);
                        this.coeChildSpinner = false;
                    }
                });
            }
        }
    }

    deleteRow(row: Phone) {
        let id = row.partyContactMechanisms.ID;
        let removedItem = this.dataSource.data.find((u: Phone) => u.partyContactMechanisms.ID == id);
        this.dataSource.data = this.dataSource.data.filter((u: Phone) => u.partyContactMechanisms.ID !== id);
        if (this.relatedPartyContactMechStudents.length > 0)
            row.partyContactMechanisms.RELATED_PARTY_CONTACT_MECHANISM_STUDENTS = this.relatedPartyContactMechStudents;
        //exiting record deleted then notify otherwise send null
        if (removedItem?.partyContactMechanisms.ID! >= 1) {
            this.emitdataSource(removedItem?.partyContactMechanisms, id);
        } else {
            this.emitdataSource(undefined, id);
        }
        this.kidsInfoByCoe = false;
        row.isEdit = false;
        row.isDelete = false;
        this.coeChildSpinner = false;
    }

    cancelRow(row: Phone) {
        this.kidsInfoByCoe = false;
        row.isEdit = false;
        row.isDelete = false;
        this.coeChildSpinner = false;
        //revert back to original state
        //get the original data from PhoneData and update the row else remove the data.
        let telePhone = this.lstTelePhonedata.find((x) => x.partyContactMechanisms.ID === row.partyContactMechanisms.ID);
        if (telePhone != undefined && telePhone.partyContactMechanisms.ID! > 0) {
            row.partyContactMechanisms = this.initialPartyContactMech;
        } else {
            this.dataSource.data = this.dataSource.data.filter((u: Phone) => u.partyContactMechanisms.ID !== row.partyContactMechanisms.ID);
        }
    }

    disableSubmit(row: Phone) {
        if (
            row.partyContactMechanisms.PARTY_CONTACT_MECHANISM_PURPOSES?.[0]?.CONTACT_MECHANISM_PURPOSE_TYPES?.TYPE &&
            (row.partyContactMechanisms.CONTACT_MECHANISMS!.TELEPHONE_NUMBERS?.[0]?.PHONE_NUMBER?.length || 0) > 11
        ) {
            return false;
        } else return true;
    }

    isRowEditable(row: Phone) {
        const now = new Date().getTime();

        if (row.partyContactMechanisms?.ID! > 0) {
            let type = row.partyContactMechanisms.PARTY_CONTACT_MECHANISM_PURPOSES![0]?.CONTACT_MECHANISM_PURPOSE_TYPES?.TYPE;
            let filterTypes = this.lstTelePhonedata.filter(
                (x) => x.partyContactMechanisms.PARTY_CONTACT_MECHANISM_PURPOSES![0]?.CONTACT_MECHANISM_PURPOSE_TYPES?.TYPE === type
            );
            if (filterTypes.length == 1) return true;
            else {
                filterTypes.sort((a, b) => {
                    return (
                        (b.partyContactMechanisms.CREATED_DATE! ? this.cleanDatePipe.transform(b.partyContactMechanisms.CREATED_DATE!)?.getTime() : now) -
                        (a.partyContactMechanisms.CREATED_DATE! ? this.cleanDatePipe.transform(a.partyContactMechanisms.CREATED_DATE!)?.getTime() : now)
                    );
                });
                return filterTypes.findIndex((x) => x.partyContactMechanisms.ID == row.partyContactMechanisms.ID) >= 1 ? false : true;
                //return filterTypes[0].partyContactMechanisms.ID === row.partyContactMechanisms.ID;
            }
        } else {
            return true;
        }
    }

    buildContactMechanisms(): PartyContactMechanisms {
        const arrPCMId = this.toNumberArray(this.dataSource.data);
        let min = arrPCMId.length > 0 ? arrPCMId.reduce((a, b) => Math.min(a, b)) : 0;
        min = min > 0 ? -1 : min - 1;

        let tempPCM = new PartyContactMechanisms();
        tempPCM = {
            ID: min,
            PARTY_ROLE_TYPES: this.partyRoleType,
            PARTY_CONTACT_MECHANISM_PURPOSES: [{ CONTACT_MECHANISM_PURPOSE_TYPES: undefined }],
            CONTACT_MECHANISMS: {
                CONTACT_MECHANISM_TYPES: this.getContactMechanismType('Phone'),
                POSTAL_ADDRESSES: [{}],
                EMAILS: [],
                TELEPHONE_NUMBERS: [
                    {
                        PHONE_NUMBER: '',
                        EXT: ''
                    }
                ]
            }
        };

        return tempPCM;
    }

    compareFn(o1: any, o2: any) {
        if (!o1 || !o2) {
            return false;
        }

        return o1.ID === o2.ID;
    }

    emitdataSource(removedItem?: PartyContactMechanisms, id?: number) {
        let eventChangedPCM: PartyContactMechanisms[] = this.dataSource.data.map((x) => x.partyContactMechanisms);

        this.partyContactMechanismsChange.emit({ editpartyContactMechanisms: eventChangedPCM, deletePartyContactMechanisms: removedItem });
    }

    coeStudentsEventEmitter(relatedContactMechStudents: STUDENT[]) {
        this.relatedPartyContactMechStudents = relatedContactMechStudents;
    }
    //Change this API service to read from ngrx store
    getContactMechanismTypes() {
        this.accessService.getContactMechanism().subscribe((res: ContactMechanismTypes[]) => {
            this.contactMechanismTypes = res;
        });
        /*this.contactMechanismsService.indexContactMechanismTypes().subscribe((res: any) => {
            this.contactMechanismTypes = res.contactMechanismTypes;
        });*/
    }
    getContactMechanismType(type: string): ContactMechanismTypes | undefined {
        let output: ContactMechanismTypes | undefined = new ContactMechanismTypes();
        output = this.contactMechanismTypes.find((contactMechanismType) => {
            return contactMechanismType.TYPE === type;
        });
        return output;
    }

    getContactMechanismPurposeTypes() {
        this.accessService.getContactMechanismPurpose().subscribe((res: ContactMechanismPurposeTypes[]) => {
            let a: ContactMechanismPurposeTypes[] = res;
            this.filterTypes.forEach((type) => this.contactMechanismPurposeTypes.push(a.find((x) => x.TYPE == type)!));
        });

        /*this.contactMechanismsService.indexContactMechanismPurposeTypes().subscribe((res: any) => {
            let a: ContactMechanismPurposeTypes[] = res.contactMechanismPurposeTypes;
            this.filterTypes.forEach((type) => this.contactMechanismPurposeTypes.push(a.find((x) => x.TYPE == type)!));
        });*/
    }

    getPartyRoleType() {
        const type = this.type === 'People' || '' ? 'Person' : this.type;
        this.accessService.getPartyRoleTypes().subscribe((res: PartyRoleTypes[]) => {
            let prType = res.find((x: PartyRoleTypes) => x.TYPE === type);
            if (prType != undefined && prType.ID > 0) {
                this.partyRoleType = prType;
            }
        });

        /*this.partyRolesService.indexPartyRoleTypesByCategory(this.type).subscribe((res) => {
            const type = this.type === 'People' || '' ? 'Person' : this.type;

            this.partyRoleType = res.partyRoleTypes?.find((prt: PartyRoleTypes) => {
                return prt.TYPE === type;
            });
        });*/
    }

    toNumberArray(array: Phone[]): number[] {
        let returnArray: number[] = [];

        array.forEach((obj) => {
            obj.partyContactMechanisms.ID ? returnArray.push(obj.partyContactMechanisms.ID) : null;
        });

        return returnArray;
    }

    getCoeRelatedStudents() {
        let coeRelatedStudentPayload: any = { party: { ID: this.partyId } };

        this.studentService.getCoeRelatedStudents(coeRelatedStudentPayload).subscribe((x) => {
            if (x['coes'] === undefined) {
                if (x['msg'] !== undefined) {
                    this.initialCoeRelatedStudents = [];
                }
            } else {
                this.initialCoeRelatedStudents = JSON.parse(x['coes']);
            }
        });
    }
}

export const PhoneColumns = [
    {
        key: 'isEdit',
        type: 'boolean',
        label: ''
    },
    {
        key: 'activeDate',
        type: 'date',
        label: 'Active Date'
    },
    {
        key: 'phoneType',
        type: 'text',
        label: 'Phone Type'
    },
    {
        key: 'phone',
        type: 'text',
        label: 'Phone',
        required: true
    }

];
